import { useEffect } from "react"
import { EventTypes } from 'stream-chat'
import { ChatChannelInstance } from "../types"
import { useDebounce } from "../utils"

type Event = {
  type: EventTypes
  callback: (event: any) => void
}

export type UseChatEventsDebouncedOptions = {
  channel: ChatChannelInstance
  enabled?: boolean
  events: Event[]
  debounceTime?: number
}

export function useChatEventsDebounced(options: UseChatEventsDebouncedOptions) {
  const { channel, enabled = true, events = [], debounceTime = 200} = options
  const { debounce } = useDebounce(debounceTime)

  useEffect(() => {
    if (!channel || !enabled) return
    const channelSubs = events.map(event => channel.on(event.type, (e) => debounce(() => event.callback(e))))

    return () => {
      channelSubs.forEach(s => s?.unsubscribe?.())
    }
  }, [enabled, channel?.id, events?.join(','), debounce])
}
